import type { ProgramPortfolio, ProgramDetails } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getProgramWallets = async (id: ProgramDetails['id']) => {
  try {
    const { data } = await api.get<{
      data: { portfolios: ProgramPortfolio[] };
    }>(apiConfig.routes.entertainment.program.portfolio(id));

    return data.data.portfolios;
  } catch {
    const { data } = await api.get<{
      data: { portfolios: ProgramPortfolio[] };
    }>(apiConfig.routes.entertainment.program.publicPortfolio(id));

    return data.data.portfolios;
  }
};

export const useGetProgramWallets = (id: ProgramDetails['id']) =>
  useQuery({
    queryKey: ['program', id, 'wallets'],
    queryFn: () => getProgramWallets(id),
    enabled: !!id,
  });
